import styles from '../../css/Report.module.css';
//chart
import Line from '../../component/ChartsLine';
import Column from '../../component/ChartsColumn';
import Pie from '../../component/ChartsPie';
// import Area from '../../component/ChartStackedArea';
import Chart3DColumn from '../../component/Chart3DColumn';
// import ChartTreemap from '../../component/ChartTreemap';

export default function Component({
	itemData

}) {
	// console.log(itemData.omega[0].name)
	return (
		<div className={styles.resultContainer}>
			{/* <h1>업종분석</h1>

			<div className={styles.area}>
				<p>해당 구역에서 선택한 업종의 개수는 00개입니다.</p>
			</div> */}
			<div className={styles.area}>
				<h2>회복탄력성</h2>
				<p>2021년도 회복탄력성이 가장 높은 업종은 {itemData.omega[0].name}입니다. <br/>회복탄력성은 {itemData.omega[0].data[5]}% 입니다.</p>
				<div style={{ display: 'flex', flexFlow:'column wrap' }}>

					<div className={styles.graph}>
						<Line chartData={itemData.omega} title={'업종 TOP5 년도별 회복탄력성'} />
					</div>
					<div className={styles.graph}>
						<Column chartData={itemData.numStore} title={'업종 TOP5 년도별 상점 수 변화'} />
					</div>

				</div>
			</div>

			<div className={styles.area}>
				<h2>업종분포 현황</h2>
				<p>선택 구역에선 {itemData.same[0][0]}업종이 가장 많습니다.</p>
				<div style={{ display: 'flex', flexFlow: 'column wrap' }}>
					<div className={styles.graph}>
						<Pie chartData={itemData.same} title={'업종별 분표율'} />
					</div>
					<div className={styles.graph}>
						<Chart3DColumn chartData={itemData.same} title={'업종별 분포수'} />
					</div>
					{/* <div className={styles.graph}>
						<Area chartData={itemData.same} title={''} />
					</div> */}
				</div>
				{/* <div style={{ display: 'flex', justifyContent: 'space-between' }}>
					<div className={styles.graphFull}>
						<ChartTreemap chartData={itemData.same} title={''} />
					</div>
				</div> */}
			</div>
		</div>
	)
}